export default "__VITE_ASSET__DKs6jpiu__"